// @flow
import React from 'react'
import type { OrderState } from '../../services/myprofile/types'
import type { AuctionState } from '../../services/auction/types'
import type { BidState } from '../../services/bid/types'
import classNames from 'classnames'
import HeadingEpsilon from '../headings/heading-epsilon'
import SimpleStateTag from '../tags/simple-state-tag'
import OrderStateTag from '../tags/order-state-tag'
import ImgCover from '../utilities/img-cover'
import CaptionText from '../texts/caption-text'
import SmallText from '../texts/small-text'
import IconButton from '../buttons/icon-button'
import Icon from '../icons/icon'

type CardHorizontalActionsProps = {
  title: string,
  subtitle: string,
  subsubtitle: string,
  caption: string,
  imageUrl: string,
  imagePlaceholder: string,
  hasStateTag: boolean,
  tagType: 'success' | 'warning' | 'info',
  tagBackground: boolean,
  tagText: string,
  tagIcon: string,
  hasActions: boolean,
  onViewDetail: () => void,
  onEdit: () => void,
  onDelete: () => void,
  bidState: BidState,
  auctionState: AuctionState,
  orderState: OrderState
}

const CardHorizontalActions = (props: CardHorizontalActionsProps) => {
  const {
    bidState,
    auctionState,
    orderState,
    hasStateTag,
    imageUrl,
    imagePlaceholder,
    tagType,
    tagBackground,
    tagText,
    tagIcon,
    title,
    subtitle,
    subsubtitle,
    caption,
    hasActions,
    onEdit,
    onDelete,
    onViewDetail
  } = props
  const classes = classNames('card horizontal', {
    'has-actions': bidState || auctionState || orderState,
    'has-state-tag': hasStateTag
  })
  return (
    <div className={classes}>
      <div className='card-caption'>
        {imageUrl ? (
          <ImgCover src={imageUrl} />
        ) : (
          <Icon name={imagePlaceholder} />
        )}
      </div>
      <div className='card-body actions-card'>
        {hasStateTag && (
          <SimpleStateTag
            type={tagType}
            hasBackground={tagBackground}
            text={tagText}
            iconName={tagIcon}
          />
        )}
        {orderState ? <OrderStateTag orderState={orderState} /> : null}
        <HeadingEpsilon>{title}</HeadingEpsilon>
        {subtitle && <SmallText light>{subtitle}</SmallText>}
        {subsubtitle && (
          <SmallText light highlight>
            {subsubtitle}
          </SmallText>
        )}
        <CaptionText light>{caption}</CaptionText>
        {hasActions && (
          <div className='actions'>
            <IconButton iconName='edit' onClick={onEdit} />
            <IconButton iconName='delete-bin' onClick={onDelete} />
          </div>
        )}
      </div>
      {!hasActions && (
        <div>
          <div className='fake-button'>
            <Icon name='goto' />
          </div>
        </div>
      )}
      {!hasActions && (
        <button className='wrapper-button' onClick={onViewDetail} />
      )}
    </div>
  )
}

CardHorizontalActions.defaultProps = {
  imagePlaceholder: 'fundrising-events-2'
}

export default CardHorizontalActions



// WEBPACK FOOTER //
// ./src/ui/cards/card-horizontal-actions.js